<!-- Copyright: Seán I. O'Donoghue -->

<template>
  <div v-show="isBusy" class="busyOverlay" aria-live="polite" aria-busy="true">
    <div class="busyOverlayInner">
      <progress class="busyProgress" />
      <div v-if="busyMessage" class="busyMessage">{{ busyMessage }}</div>
    </div>
  </div>
</template>

<script setup>
defineProps({isBusy: {default: false}, busyMessage: {default: "Please wait…"}});
</script>

<style scoped>
.busyOverlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.65);
  backdrop-filter: blur(2px);
  pointer-events: auto;
  z-index: 10;
}
.busyOverlayInner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
}
.busyProgress {
  width: 140px;
  height: 10px;
}
.busyMessage {
  font-size: 0.95rem;
}
</style>
